/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentDefinitionVersion extends models.BaseDefinitionVersion {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentDefinitionVersion.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentDefinitionVersion>): WellArchitectedFrameworkAssessmentDefinitionVersion {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentDefinitionVersion(), model);
        WellArchitectedFrameworkAssessmentDefinitionVersion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentDefinitionVersion>): WellArchitectedFrameworkAssessmentDefinitionVersion {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentDefinitionVersion.newInstance(<WellArchitectedFrameworkAssessmentDefinitionVersion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentDefinitionVersion) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentDefinitionVersion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentDefinitionVersion): boolean {
        if (models.BaseDefinitionVersion.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentDefinitionVersion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.details) {
            models.WellArchitectedFrameworkAssessmentConfiguration.fixupPrototype(this.details);
        }
    }

    /**
     * Details of the version
     */
    details: models.WellArchitectedFrameworkAssessmentConfiguration;

    /**
     * State of the version
     */
    version_state: models.VersionState;

}
